import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App';

// Tokens first so the variables exist before Tailwind's base layer paints.
import '@/styles/tokens.css';
import '@/styles/index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('No se encontró el nodo raíz #root en index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Remove the pre-React splash once the first frame has actually been painted.
// Two frames: the first schedules React's commit, the second happens after it.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.getElementById('app-boot')?.remove();
  });
});
